"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLockOpenOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17.89 9.002l.035-2.681c-.04.614-.374.92-1 .92-.925-.003-1.073-.928-1.152-1.205C15.408 4.757 14.46 4.002 12 4.002c-4.003 0-4 2-4 5h9.89c1.407 0 2.11.667 2.11 2v9c0 1.333-.667 2-2 2H6.002c-1.335 0-2.002-.667-2.002-2V11.03c0-1.351.667-2.027 2-2.027l.002-2C6 3.667 8 2 12 2c3.348 0 5.295 1.123 5.84 3.368.045.184.074.432.087.745v.028l-.037 2.861zM6 20.002h12v-9.018H6v9.018zm5-3v-3c0-.667.333-1 1-1s1 .333 1 1v3c0 .667-.333 1-1 1s-1-.333-1-1z' }))); };
exports.default = SvgLockOpenOutline;
//# sourceMappingURL=LockOpenOutline.js.map